package link.erpango.quip.ui

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.Icon
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Scaffold
import androidx.compose.material.Snackbar
import androidx.compose.material.SnackbarDuration
import androidx.compose.material.SnackbarHost
import androidx.compose.material.SnackbarHostState
import androidx.compose.material.Text
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.Build
import androidx.compose.material.icons.filled.Done
import androidx.compose.material.icons.filled.Info
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.Settings
import androidx.compose.material.rememberScaffoldState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import androidx.compose.ui.Alignment
import androidx.compose.foundation.layout.width
import androidx.compose.material.icons.filled.ArrowBack
import kotlinx.coroutines.launch
import link.erpango.quip.data.remote.DResponse
import link.erpango.quip.domain.entities.DVehicle
import link.erpango.quip.domain.entities.VehicleType
import link.erpango.quip.domain.noteimport.ImportDraft
import link.erpango.quip.domain.noteimport.NoteImportTarget
import link.erpango.quip.domain.usecases.GarageErrors
import link.erpango.quip.features.garage.GarageViewModel
import link.erpango.quip.features.noteimport.NoteImportSelection
import link.erpango.quip.features.noteimport.NoteImportViewModel
import link.erpango.quip.theme.VehicleColors
import link.erpango.quip.ui.noteimport.NoteImportDialog
import link.erpango.quip.ui.noteimport.NoteImportEntryCard
import link.erpango.quip.ui.noteimport.NoteImportReviewBanner
import link.erpango.quip.ui.noteimport.SuggestionMarker
import link.erpango.quip.ui.noteimport.rememberFormSuggestions
import link.erpango.quip.domain.catalog.DefaultSparePartCatalog
import link.erpango.quip.QuipConstants
import link.erpango.quip.theme.QuipColors
import link.erpango.quip.utils.DatetimeUtils
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import link.erpango.quip.ui.components.QuipDropdownTextField
import link.erpango.quip.ui.components.QuipPrimaryButton
import link.erpango.quip.ui.components.QuipSectionHeader
import link.erpango.quip.ui.components.QuipTextField
import link.erpango.quip.ui.components.QuipTransparentHeader
import link.erpango.quip.ui.components.VehicleColorPicker
import org.jetbrains.compose.resources.stringResource
import quip.composeapp.generated.resources.Res
import quip.composeapp.generated.resources.brand
import quip.composeapp.generated.resources.color
import quip.composeapp.generated.resources.cylinder_count
import quip.composeapp.generated.resources.front_bulb_type
import quip.composeapp.generated.resources.rear_bulb_type
import quip.composeapp.generated.resources.battery_specs
import quip.composeapp.generated.resources.coolant_type
import quip.composeapp.generated.resources.engine_details
import quip.composeapp.generated.resources.engine_oil
import quip.composeapp.generated.resources.front_above_160
import quip.composeapp.generated.resources.front_below_160
import quip.composeapp.generated.resources.front_tire_size
import quip.composeapp.generated.resources.general_information
import quip.composeapp.generated.resources.model
import quip.composeapp.generated.resources.motor_section
import quip.composeapp.generated.resources.owner
import quip.composeapp.generated.resources.please_complete_required_fields
import quip.composeapp.generated.resources.plate
import quip.composeapp.generated.resources.rear_above_160
import quip.composeapp.generated.resources.rear_below_160
import quip.composeapp.generated.resources.rear_tire_size
import quip.composeapp.generated.resources.recommended_fuel
import quip.composeapp.generated.resources.required
import quip.composeapp.generated.resources.save_vehicle
import quip.composeapp.generated.resources.tire_pressure_bar
import quip.composeapp.generated.resources.tires_section
import quip.composeapp.generated.resources.update_vehicle
import quip.composeapp.generated.resources.vehicle_added_successfully
import quip.composeapp.generated.resources.vehicle_updated_successfully
import quip.composeapp.generated.resources.vin
import quip.composeapp.generated.resources.year
import quip.composeapp.generated.resources.vehicle_type
import quip.composeapp.generated.resources.vehicle_type_car
import quip.composeapp.generated.resources.vehicle_type_motorcycle
import quip.composeapp.generated.resources.vehicle_type_truck
import quip.composeapp.generated.resources.vehicle_type_van
import quip.composeapp.generated.resources.vehicle_type_bus
import quip.composeapp.generated.resources.vehicle_type_other
import quip.composeapp.generated.resources.next_revision_date
import quip.composeapp.generated.resources.next_itv_date
import quip.composeapp.generated.resources.first_registration_date
import quip.composeapp.generated.resources.error_adding_vehicle
import quip.composeapp.generated.resources.note_import_duplicate_warning
import quip.composeapp.generated.resources.vehicle_duplicate_vin

@Composable
fun AddVehicleScreen(
    innerPadding: PaddingValues,
    viewModel: GarageViewModel,
    vehicleToEdit: DVehicle? = null,
    onVehicleAdded: () -> Unit = {},
    onBackClick: () -> Unit,
    // Autocomplete data
    distinctOwners: List<String> = emptyList(),
    /** "Rellenar desde nota": solo en modo alta; null lo oculta. */
    noteImportViewModel: NoteImportViewModel? = null,
    /** Propietario sugerido al rellenar desde nota si la nota no lo dice (el usuario actual). */
    ownerSuggestion: String? = null,
    /** "Importar todo": la nota trae más de un vehículo o elemento; se pasa a la importación masiva. */
    onImportAllFromNote: ((note: String, draft: ImportDraft) -> Unit)? = null
) {
    // Localized strings
    val generalInformation = stringResource(Res.string.general_information)
    val motorSection = stringResource(Res.string.motor_section)
    val tiresSection = stringResource(Res.string.tires_section)
    val tirePressureBar = stringResource(Res.string.tire_pressure_bar)
    val vinLabel = stringResource(Res.string.vin)
    val plateLabel = stringResource(Res.string.plate)
    val brandLabel = stringResource(Res.string.brand)
    val modelLabel = stringResource(Res.string.model)
    val yearLabel = stringResource(Res.string.year)
    val colorLabel = stringResource(Res.string.color)
    val ownerLabel = stringResource(Res.string.owner)
    val vehicleTypeLabel = stringResource(Res.string.vehicle_type)
    
    // Vehicle type labels map
    val vehicleTypeLabels = mapOf(
        VehicleType.CAR to stringResource(Res.string.vehicle_type_car),
        VehicleType.MOTORCYCLE to stringResource(Res.string.vehicle_type_motorcycle),
        VehicleType.TRUCK to stringResource(Res.string.vehicle_type_truck),
        VehicleType.VAN to stringResource(Res.string.vehicle_type_van),
        VehicleType.BUS to stringResource(Res.string.vehicle_type_bus),
        VehicleType.OTHER to stringResource(Res.string.vehicle_type_other)
    )
    val engineDetailsLabel = stringResource(Res.string.engine_details)
    val engineOilLabel = stringResource(Res.string.engine_oil)
    val recommendedFuelLabel = stringResource(Res.string.recommended_fuel)
    val cylinderCountLabel = stringResource(Res.string.cylinder_count)
    val frontBulbTypeLabel = stringResource(Res.string.front_bulb_type)
    val rearBulbTypeLabel = stringResource(Res.string.rear_bulb_type)
    val batterySpecsLabel = stringResource(Res.string.battery_specs)
    val coolantTypeLabel = stringResource(Res.string.coolant_type)
    val frontTireSizeLabel = stringResource(Res.string.front_tire_size)
    val rearTireSizeLabel = stringResource(Res.string.rear_tire_size)
    val frontBelow160Label = stringResource(Res.string.front_below_160)
    val rearBelow160Label = stringResource(Res.string.rear_below_160)
    val frontAbove160Label = stringResource(Res.string.front_above_160)
    val rearAbove160Label = stringResource(Res.string.rear_above_160)
    val updateVehicle = stringResource(Res.string.update_vehicle)
    val saveVehicle = stringResource(Res.string.save_vehicle)
    val vehicleUpdatedSuccessfully = stringResource(Res.string.vehicle_updated_successfully)
    val vehicleAddedSuccessfully = stringResource(Res.string.vehicle_added_successfully)
    val pleaseCompleteRequiredFields = stringResource(Res.string.please_complete_required_fields)
    val required = stringResource(Res.string.required)
    val nextRevisionDateLabel = stringResource(Res.string.next_revision_date)
    val nextItvDateLabel = stringResource(Res.string.next_itv_date)
    val firstRegistrationDateLabel = stringResource(Res.string.first_registration_date)
    val vehicleDuplicateVin = stringResource(Res.string.vehicle_duplicate_vin)
    val errorAddingVehicle = stringResource(Res.string.error_adding_vehicle)
    val duplicateWarning = stringResource(Res.string.note_import_duplicate_warning)
    val colorNames = VehicleColors.allColors.associate { it.id to VehicleColors.getStringFromKey(it.nameResKey) }

    // State variables
    var vin by remember { mutableStateOf(vehicleToEdit?.vin ?: "") }
    var plate by remember { mutableStateOf(vehicleToEdit?.plate ?: "") }
    var brand by remember { mutableStateOf(vehicleToEdit?.brand ?: "") }
    var model by remember { mutableStateOf(vehicleToEdit?.model ?: "") }
    var year by remember { mutableStateOf(vehicleToEdit?.year?.toString() ?: "") }
    var color by remember { mutableStateOf(vehicleToEdit?.color ?: "") }
    var owner by remember { mutableStateOf(vehicleToEdit?.owner ?: "") }
    var vehicleType by remember { mutableStateOf(vehicleToEdit?.vehicleType ?: VehicleType.CAR) }
    var nextRevisionDate by remember { mutableStateOf(vehicleToEdit?.nextRevisionDate) }
    var nextItvDate by remember { mutableStateOf(vehicleToEdit?.nextItvDate) }
    var firstRegistrationDate by remember { mutableStateOf(vehicleToEdit?.firstRegistrationDate) }
    
    // Engine details
    var engineOil by remember { mutableStateOf(vehicleToEdit?.engineOil ?: "") }
    var recommendedFuel by remember { mutableStateOf(vehicleToEdit?.recommendedFuel ?: "") }
    var engineDetails by remember { mutableStateOf(vehicleToEdit?.engineDetails ?: "") }
    var cylinderCount by remember { mutableStateOf(vehicleToEdit?.cylinderCount?.toString() ?: "") }
    var frontBulbType by remember { mutableStateOf(vehicleToEdit?.frontBulbType ?: "") }
    var rearBulbType by remember { mutableStateOf(vehicleToEdit?.rearBulbType ?: "") }
    var batterySpecs by remember { mutableStateOf(vehicleToEdit?.batterySpecs ?: "") }
    var coolantType by remember { mutableStateOf(vehicleToEdit?.coolantType ?: "") }

    // Tires
    var frontTireSize by remember { mutableStateOf(vehicleToEdit?.frontTireSize ?: "") }
    var rearTireSize by remember { mutableStateOf(vehicleToEdit?.rearTireSize ?: "") }
    var frontTirePressureBelow160 by remember { mutableStateOf(vehicleToEdit?.frontTirePressureBelow160?.toString() ?: "") }
    var rearTirePressureBelow160 by remember { mutableStateOf(vehicleToEdit?.rearTirePressureBelow160?.toString() ?: "") }
    var frontTirePressureAbove160 by remember { mutableStateOf(vehicleToEdit?.frontTirePressureAbove160?.toString() ?: "") }
    var rearTirePressureAbove160 by remember { mutableStateOf(vehicleToEdit?.rearTirePressureAbove160?.toString() ?: "") }

    // Validation error states
    var vinError by remember { mutableStateOf(false) }
    var plateError by remember { mutableStateOf(false) }
    var brandError by remember { mutableStateOf(false) }
    var modelError by remember { mutableStateOf(false) }
    var yearError by remember { mutableStateOf(false) }
    var colorError by remember { mutableStateOf(false) }
    var ownerError by remember { mutableStateOf(false) }

    // "Rellenar desde nota"
    val suggestions = rememberFormSuggestions<VehicleFormField>()
    var showNoteImport by remember { mutableStateOf(false) }
    var showReviewBanner by remember { mutableStateOf(false) }
    var alreadyInGarage by remember { mutableStateOf(false) }
    var vehicleTypeTouched by remember { mutableStateOf(vehicleToEdit != null) }
    var isSaving by remember { mutableStateOf(false) }

    fun applyNoteSelection(selection: NoteImportSelection.Vehicle) {
        val draft = selection.draft
        val note = selection.note
        suggestions.clearAll()
        suggestions.apply(VehicleFormField.VIN, draft.vin, note, vin.isBlank(), { it == vin }) { vin = it; vinError = false }
        suggestions.apply(VehicleFormField.PLATE, draft.plate, note, plate.isBlank(), { it.equals(plate, ignoreCase = true) }) { plate = it; plateError = false }
        suggestions.apply(VehicleFormField.BRAND, draft.brand, note, brand.isBlank(), { it.equals(brand, ignoreCase = true) }) {
            if (!it.equals(brand, ignoreCase = true)) model = ""
            brand = it; brandError = false
        }
        suggestions.apply(VehicleFormField.MODEL, draft.model, note, model.isBlank(), { it.equals(model, ignoreCase = true) }) { model = it; modelError = false }
        suggestions.apply(VehicleFormField.YEAR, draft.year, note, year.isBlank(), { it.toString() == year }) { year = it.toString(); yearError = false }
        suggestions.apply(
            VehicleFormField.TYPE, draft.vehicleType, note, !vehicleTypeTouched, { it == vehicleType },
            display = { vehicleTypeLabels[it] ?: it.code },
        ) { vehicleType = it }
        suggestions.apply(
            VehicleFormField.COLOR, draft.color, note, color.isBlank(), { it == color },
            display = { colorNames[it] ?: it },
        ) { color = it; colorError = false }
        suggestions.apply(VehicleFormField.OWNER, draft.owner, note, owner.isBlank(), { it.equals(owner, ignoreCase = true) }) { owner = it; ownerError = false }
        if (draft.owner == null && owner.isBlank() && !ownerSuggestion.isNullOrBlank()) owner = ownerSuggestion
        suggestions.apply(VehicleFormField.ENGINE_DETAILS, draft.engineDetails, note, engineDetails.isBlank(), { it == engineDetails }) { engineDetails = it }
        suggestions.apply(VehicleFormField.ENGINE_OIL, draft.engineOil, note, engineOil.isBlank(), { it == engineOil }) { engineOil = it }
        suggestions.apply(VehicleFormField.FUEL, draft.recommendedFuel, note, recommendedFuel.isBlank(), { it == recommendedFuel }) { recommendedFuel = it }
        suggestions.apply(VehicleFormField.FRONT_TIRE, draft.frontTireSize, note, frontTireSize.isBlank(), { it == frontTireSize }) { frontTireSize = it }
        suggestions.apply(VehicleFormField.REAR_TIRE, draft.rearTireSize, note, rearTireSize.isBlank(), { it == rearTireSize }) { rearTireSize = it }
        suggestions.apply(VehicleFormField.CYLINDER_COUNT, draft.cylinderCount, note, cylinderCount.isBlank(), { it.toString() == cylinderCount }) {
            cylinderCount = it.toString()
        }
        suggestions.apply(VehicleFormField.FRONT_BULB, draft.frontBulbType, note, frontBulbType.isBlank(), { it == frontBulbType }) { frontBulbType = it }
        suggestions.apply(VehicleFormField.REAR_BULB, draft.rearBulbType, note, rearBulbType.isBlank(), { it == rearBulbType }) { rearBulbType = it }
        suggestions.apply(VehicleFormField.BATTERY, draft.batterySpecs, note, batterySpecs.isBlank(), { it == batterySpecs }) { batterySpecs = it }
        suggestions.apply(VehicleFormField.COOLANT, draft.coolantType, note, coolantType.isBlank(), { it == coolantType }) { coolantType = it }
        suggestions.apply(
            VehicleFormField.FRONT_PRESSURE_BELOW_160, draft.frontTirePressureBelow160, note,
            frontTirePressureBelow160.isBlank(), { it == frontTirePressureBelow160.toDoubleOrNull() },
            display = ::formatTirePressure,
        ) { frontTirePressureBelow160 = formatTirePressure(it) }
        suggestions.apply(
            VehicleFormField.REAR_PRESSURE_BELOW_160, draft.rearTirePressureBelow160, note,
            rearTirePressureBelow160.isBlank(), { it == rearTirePressureBelow160.toDoubleOrNull() },
            display = ::formatTirePressure,
        ) { rearTirePressureBelow160 = formatTirePressure(it) }
        suggestions.apply(
            VehicleFormField.FRONT_PRESSURE_ABOVE_160, draft.frontTirePressureAbove160, note,
            frontTirePressureAbove160.isBlank(), { it == frontTirePressureAbove160.toDoubleOrNull() },
            display = ::formatTirePressure,
        ) { frontTirePressureAbove160 = formatTirePressure(it) }
        suggestions.apply(
            VehicleFormField.REAR_PRESSURE_ABOVE_160, draft.rearTirePressureAbove160, note,
            rearTirePressureAbove160.isBlank(), { it == rearTirePressureAbove160.toDoubleOrNull() },
            display = ::formatTirePressure,
        ) { rearTirePressureAbove160 = formatTirePressure(it) }
        suggestions.apply(
            VehicleFormField.FIRST_REGISTRATION, draft.firstRegistrationDate, note,
            firstRegistrationDate == null, { it == firstRegistrationDate },
            display = ::formatEpochDate,
        ) { firstRegistrationDate = it }
        suggestions.apply(
            VehicleFormField.NEXT_ITV, draft.nextItvDate, note,
            nextItvDate == null, { it == nextItvDate },
            display = ::formatEpochDate,
        ) { nextItvDate = it }
        // What the note could not fill stays flagged, like after a failed save.
        vinError = vin.isBlank()
        plateError = plate.isBlank()
        brandError = brand.isBlank()
        modelError = model.isBlank()
        yearError = year.isBlank()
        colorError = color.isBlank()
        ownerError = owner.isBlank()
        alreadyInGarage = draft.garageMatchVin != null
        showReviewBanner = true
    }

    // Snackbar handling
    var isErrorSnackbar by remember { mutableStateOf(false) }
    val snackbarHostState = remember { SnackbarHostState() }
    val coroutineScope = rememberCoroutineScope()

    Scaffold(
        scaffoldState = rememberScaffoldState(snackbarHostState = snackbarHostState),
        snackbarHost = {
            SnackbarHost(it) { data ->
                Snackbar(
                    snackbarData = data,
                    backgroundColor = if (isErrorSnackbar) Color(0xFFB00020) else QuipColors.colorPrimary,
                    contentColor = Color.White
                )
            }
        },
        backgroundColor = QuipColors.colorBackground
    ) { paddingValues ->
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(paddingValues)
                .padding(innerPadding)
                .imePadding()
        ) {
            // Header
            QuipTransparentHeader {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    androidx.compose.material.IconButton(onClick = onBackClick) {
                        Icon(
                            Icons.Default.ArrowBack,
                            contentDescription = "Back",
                            tint = QuipColors.colorText
                        )
                    }
                    Spacer(modifier = Modifier.width(8.dp))
                    Text(
                        text = if (vehicleToEdit != null) updateVehicle else saveVehicle,
                        style = MaterialTheme.typography.h5,
                        fontWeight = FontWeight.Bold,
                        color = QuipColors.colorText
                    )
                }
            }

            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .verticalScroll(rememberScrollState())
                    .padding(horizontal = 16.dp),
                verticalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                if (vehicleToEdit == null && noteImportViewModel != null) {
                    if (showReviewBanner) {
                        val missing = listOfNotNull(
                            vinLabel.takeIf { vin.isBlank() },
                            plateLabel.takeIf { plate.isBlank() },
                            brandLabel.takeIf { brand.isBlank() },
                            modelLabel.takeIf { model.isBlank() },
                            yearLabel.takeIf { year.isBlank() },
                            colorLabel.takeIf { color.isBlank() },
                            ownerLabel.takeIf { owner.isBlank() },
                        )
                        NoteImportReviewBanner(missingFields = missing, onDismiss = { showReviewBanner = false })
                        if (alreadyInGarage) {
                            Text(duplicateWarning, color = QuipColors.colorError, style = MaterialTheme.typography.body2)
                        }
                    } else {
                        NoteImportEntryCard(onClick = {
                            noteImportViewModel.open(NoteImportTarget.VEHICLE)
                            showNoteImport = true
                        })
                    }
                }

                // Información General
                QuipSectionHeader(title = generalInformation, icon = Icons.Default.Info)
                
                QuipTextField(
                    value = vin,
                    onValueChange = { vin = it; vinError = false; suggestions.clear(VehicleFormField.VIN) },
                    label = vinLabel,
                    keyboardOptions = KeyboardOptions(imeAction = ImeAction.Next),
                    enabled = vehicleToEdit == null, // VIN cannot be changed
                    isError = vinError,
                    helperText = { Text(required, color = if (vinError) Color(0xFFB00020) else QuipColors.colorText.copy(alpha = 0.6f), modifier = Modifier.padding(start = 16.dp)) }
                )
                SuggestionMarker(suggestions[VehicleFormField.VIN])
                QuipTextField(
                    value = plate,
                    onValueChange = { plate = it; plateError = false; suggestions.clear(VehicleFormField.PLATE) },
                    label = plateLabel,
                    keyboardOptions = KeyboardOptions(imeAction = ImeAction.Next),
                    isError = plateError,
                    helperText = { Text(required, color = if (plateError) Color(0xFFB00020) else QuipColors.colorText.copy(alpha = 0.6f), modifier = Modifier.padding(start = 16.dp)) }
                )
                SuggestionMarker(suggestions[VehicleFormField.PLATE])
                val brands by viewModel.catalogBrands.collectAsState()
                val models by viewModel.catalogModels.collectAsState()

                // Cargar modelos cuando cambia la marca seleccionada
                LaunchedEffect(brand) {
                    if (brand.isNotBlank()) viewModel.loadCatalogModels(brand)
                }

                QuipDropdownTextField(
                    options = brands,
                    selectedOption = brand.takeIf { it.isNotBlank() },
                    label = brandLabel,
                    isFiltrable = true,
                    isEnabled = vehicleToEdit == null,
                    isError = brandError,
                    helperText = required,
                    onOptionSelected = { _, option -> brand = option; brandError = false; suggestions.clear(VehicleFormField.BRAND); if (brand != (vehicleToEdit?.brand ?: "")) model = "" },
                    onTextChanged = { brand = it; brandError = false; suggestions.clear(VehicleFormField.BRAND) },
                    onClearOption = { brand = ""; model = ""; suggestions.clear(VehicleFormField.BRAND) },
                    keyboardOptions = KeyboardOptions(imeAction = ImeAction.Next)
                )
                SuggestionMarker(suggestions[VehicleFormField.BRAND])
                QuipDropdownTextField(
                    options = models,
                    selectedOption = model.takeIf { it.isNotBlank() },
                    label = modelLabel,
                    isFiltrable = true,
                    isEnabled = vehicleToEdit == null,
                    isError = modelError,
                    helperText = required,
                    onOptionSelected = { _, option -> model = option; modelError = false; suggestions.clear(VehicleFormField.MODEL) },
                    onTextChanged = { model = it; modelError = false; suggestions.clear(VehicleFormField.MODEL) },
                    onClearOption = { model = ""; suggestions.clear(VehicleFormField.MODEL) },
                    keyboardOptions = KeyboardOptions(imeAction = ImeAction.Next)
                )
                SuggestionMarker(suggestions[VehicleFormField.MODEL])
                QuipTextField(
                    value = year,
                    onValueChange = { year = it; yearError = false; suggestions.clear(VehicleFormField.YEAR) },
                    label = yearLabel,
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number, imeAction = ImeAction.Next),
                    enabled = vehicleToEdit == null, // Year cannot be changed (part of signature)
                    isError = yearError,
                    helperText = { Text(required, color = if (yearError) Color(0xFFB00020) else QuipColors.colorText.copy(alpha = 0.6f), modifier = Modifier.padding(start = 16.dp)) }
                )
                SuggestionMarker(suggestions[VehicleFormField.YEAR])
                
                // Vehicle Type selector
                QuipDropdownTextField(
                    options = VehicleType.entries.toList(),
                    selectedOption = vehicleType,
                    itemToStringTitle = { vehicleTypeLabels[it] ?: it.code },
                    label = vehicleTypeLabel,
                    onOptionSelected = { _, option -> vehicleType = option; vehicleTypeTouched = true; suggestions.clear(VehicleFormField.TYPE) }
                )
                SuggestionMarker(suggestions[VehicleFormField.TYPE])
                
                // Selector de color del vehículo
                VehicleColorPicker(
                    selectedColorId = color,
                    onColorSelected = { vehicleColor ->
                        color = vehicleColor.id
                        colorError = false
                        suggestions.clear(VehicleFormField.COLOR)
                    },
                    label = colorLabel,
                    isError = colorError
                )
                SuggestionMarker(suggestions[VehicleFormField.COLOR])
                
                QuipDropdownTextField(
                    options = distinctOwners,
                    selectedOption = owner.takeIf { it.isNotBlank() && distinctOwners.contains(it) },
                    label = ownerLabel,
                    isFiltrable = true,
                    isError = ownerError,
                    onOptionSelected = { _, option -> owner = option; ownerError = false; suggestions.clear(VehicleFormField.OWNER) },
                    onTextChanged = { owner = it; ownerError = false; suggestions.clear(VehicleFormField.OWNER) },
                    onClearOption = { owner = ""; suggestions.clear(VehicleFormField.OWNER) }
                )
                SuggestionMarker(suggestions[VehicleFormField.OWNER])

                DatePickerField(
                    label = nextRevisionDateLabel,
                    currentDate = nextRevisionDate,
                    onDateSelected = { nextRevisionDate = it }
                )

                DatePickerField(
                    label = nextItvDateLabel,
                    currentDate = nextItvDate,
                    onDateSelected = { nextItvDate = it; suggestions.clear(VehicleFormField.NEXT_ITV) }
                )
                SuggestionMarker(suggestions[VehicleFormField.NEXT_ITV])

                DatePickerField(
                    label = firstRegistrationDateLabel,
                    currentDate = firstRegistrationDate,
                    onDateSelected = { firstRegistrationDate = it; suggestions.clear(VehicleFormField.FIRST_REGISTRATION) }
                )
                SuggestionMarker(suggestions[VehicleFormField.FIRST_REGISTRATION])

                // Motor
                QuipSectionHeader(title = motorSection, icon = Icons.Default.Build)
                
                QuipTextField(
                    value = engineDetails,
                    onValueChange = { engineDetails = it; suggestions.clear(VehicleFormField.ENGINE_DETAILS) },
                    label = engineDetailsLabel,
                    keyboardOptions = KeyboardOptions(imeAction = ImeAction.Next)
                )
                SuggestionMarker(suggestions[VehicleFormField.ENGINE_DETAILS])
                QuipDropdownTextField(
                    options = link.erpango.quip.QuipConstants.VehicleAttributes.EngineOilTypes,
                    selectedOption = engineOil,
                    label = engineOilLabel,
                    isFiltrable = true,
                    onOptionSelected = { _, option -> engineOil = option; suggestions.clear(VehicleFormField.ENGINE_OIL) },
                    onTextChanged = { engineOil = it; suggestions.clear(VehicleFormField.ENGINE_OIL) },
                    onClearOption = { engineOil = ""; suggestions.clear(VehicleFormField.ENGINE_OIL) }
                )
                SuggestionMarker(suggestions[VehicleFormField.ENGINE_OIL])
                QuipDropdownTextField(
                    options = link.erpango.quip.QuipConstants.VehicleAttributes.FuelTypes,
                    selectedOption = recommendedFuel,
                    label = recommendedFuelLabel,
                    isFiltrable = true,
                    onOptionSelected = { _, option -> recommendedFuel = option; suggestions.clear(VehicleFormField.FUEL) },
                    onTextChanged = { recommendedFuel = it; suggestions.clear(VehicleFormField.FUEL) },
                    onClearOption = { recommendedFuel = ""; suggestions.clear(VehicleFormField.FUEL) }
                )
                SuggestionMarker(suggestions[VehicleFormField.FUEL])
                QuipDropdownTextField(
                    options = link.erpango.quip.QuipConstants.VehicleAttributes.CylinderCounts.map { it.toString() },
                    selectedOption = cylinderCount,
                    label = cylinderCountLabel,
                    onOptionSelected = { _, option -> cylinderCount = option; suggestions.clear(VehicleFormField.CYLINDER_COUNT) },
                    onTextChanged = { cylinderCount = it; suggestions.clear(VehicleFormField.CYLINDER_COUNT) },
                    onClearOption = { cylinderCount = ""; suggestions.clear(VehicleFormField.CYLINDER_COUNT) },
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number, imeAction = ImeAction.Next)
                )
                SuggestionMarker(suggestions[VehicleFormField.CYLINDER_COUNT])
                QuipTextField(
                    value = frontBulbType,
                    onValueChange = { frontBulbType = it; suggestions.clear(VehicleFormField.FRONT_BULB) },
                    label = frontBulbTypeLabel,
                    keyboardOptions = KeyboardOptions(imeAction = ImeAction.Next)
                )
                SuggestionMarker(suggestions[VehicleFormField.FRONT_BULB])
                QuipTextField(
                    value = rearBulbType,
                    onValueChange = { rearBulbType = it; suggestions.clear(VehicleFormField.REAR_BULB) },
                    label = rearBulbTypeLabel,
                    keyboardOptions = KeyboardOptions(imeAction = ImeAction.Next)
                )
                SuggestionMarker(suggestions[VehicleFormField.REAR_BULB])
                QuipTextField(
                    value = batterySpecs,
                    onValueChange = { batterySpecs = it; suggestions.clear(VehicleFormField.BATTERY) },
                    label = batterySpecsLabel,
                    keyboardOptions = KeyboardOptions(imeAction = ImeAction.Next)
                )
                SuggestionMarker(suggestions[VehicleFormField.BATTERY])
                QuipTextField(
                    value = coolantType,
                    onValueChange = { coolantType = it; suggestions.clear(VehicleFormField.COOLANT) },
                    label = coolantTypeLabel,
                    keyboardOptions = KeyboardOptions(imeAction = ImeAction.Next)
                )
                SuggestionMarker(suggestions[VehicleFormField.COOLANT])

                // Neumáticos
                QuipSectionHeader(title = tiresSection, icon = Icons.Default.Settings)
                
                QuipDropdownTextField(
                    options = link.erpango.quip.QuipConstants.VehicleAttributes.TireSizes,
                    selectedOption = frontTireSize.takeIf { it.isNotBlank() },
                    label = frontTireSizeLabel,
                    isFiltrable = true,
                    onOptionSelected = { _, option -> frontTireSize = option; suggestions.clear(VehicleFormField.FRONT_TIRE) },
                    onTextChanged = { frontTireSize = it; suggestions.clear(VehicleFormField.FRONT_TIRE) },
                    onClearOption = { frontTireSize = ""; suggestions.clear(VehicleFormField.FRONT_TIRE) },
                    keyboardOptions = KeyboardOptions(imeAction = ImeAction.Next)
                )
                SuggestionMarker(suggestions[VehicleFormField.FRONT_TIRE])
                QuipDropdownTextField(
                    options = link.erpango.quip.QuipConstants.VehicleAttributes.TireSizes,
                    selectedOption = rearTireSize.takeIf { it.isNotBlank() },
                    label = rearTireSizeLabel,
                    isFiltrable = true,
                    onOptionSelected = { _, option -> rearTireSize = option; suggestions.clear(VehicleFormField.REAR_TIRE) },
                    onTextChanged = { rearTireSize = it; suggestions.clear(VehicleFormField.REAR_TIRE) },
                    onClearOption = { rearTireSize = ""; suggestions.clear(VehicleFormField.REAR_TIRE) },
                    keyboardOptions = KeyboardOptions(imeAction = ImeAction.Next)
                )
                SuggestionMarker(suggestions[VehicleFormField.REAR_TIRE])
                
                // Presiones
                QuipSectionHeader(title = tirePressureBar, icon = Icons.Default.Settings)
                
                // <160km/h
                QuipTextField(
                    value = frontTirePressureBelow160,
                    onValueChange = { frontTirePressureBelow160 = it; suggestions.clear(VehicleFormField.FRONT_PRESSURE_BELOW_160) },
                    label = frontBelow160Label,
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal, imeAction = ImeAction.Next)
                )
                SuggestionMarker(suggestions[VehicleFormField.FRONT_PRESSURE_BELOW_160])
                QuipTextField(
                    value = rearTirePressureBelow160,
                    onValueChange = { rearTirePressureBelow160 = it; suggestions.clear(VehicleFormField.REAR_PRESSURE_BELOW_160) },
                    label = rearBelow160Label,
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal, imeAction = ImeAction.Next)
                )
                SuggestionMarker(suggestions[VehicleFormField.REAR_PRESSURE_BELOW_160])

                // >160km/h
                QuipTextField(
                    value = frontTirePressureAbove160,
                    onValueChange = { frontTirePressureAbove160 = it; suggestions.clear(VehicleFormField.FRONT_PRESSURE_ABOVE_160) },
                    label = frontAbove160Label,
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal, imeAction = ImeAction.Next)
                )
                SuggestionMarker(suggestions[VehicleFormField.FRONT_PRESSURE_ABOVE_160])
                QuipTextField(
                    value = rearTirePressureAbove160,
                    onValueChange = { rearTirePressureAbove160 = it; suggestions.clear(VehicleFormField.REAR_PRESSURE_ABOVE_160) },
                    label = rearAbove160Label,
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal, imeAction = ImeAction.Done)
                )
                SuggestionMarker(suggestions[VehicleFormField.REAR_PRESSURE_ABOVE_160])

                Spacer(modifier = Modifier.height(16.dp))

                QuipPrimaryButton(
                    text = if (vehicleToEdit != null) updateVehicle else saveVehicle,
                    onClick = {
                        vinError = vin.isBlank()
                        plateError = plate.isBlank()
                        brandError = brand.isBlank()
                        modelError = model.isBlank()
                        yearError = year.isBlank()
                        colorError = color.isBlank()
                        ownerError = owner.isBlank()
                        if (!vinError && !plateError && !brandError && !modelError && !yearError && !colorError && !ownerError) {
                            val vehicle = DVehicle(
                                vin = vin,
                                plate = plate,
                                brand = brand,
                                model = model,
                                vehicleType = vehicleType,
                                year = year.toIntOrNull() ?: 0,
                                color = color,
                                owner = owner,
                                engineOil = engineOil,
                                frontTireSize = frontTireSize,
                                rearTireSize = rearTireSize,
                                frontTirePressureBelow160 = frontTirePressureBelow160.toDoubleOrNull() ?: 0.0,
                                rearTirePressureBelow160 = rearTirePressureBelow160.toDoubleOrNull() ?: 0.0,
                                frontTirePressureAbove160 = frontTirePressureAbove160.toDoubleOrNull() ?: 0.0,
                                rearTirePressureAbove160 = rearTirePressureAbove160.toDoubleOrNull() ?: 0.0,
                                recommendedFuel = recommendedFuel,
                                engineDetails = engineDetails,

                                cylinderCount = cylinderCount.toIntOrNull() ?: 0,
                                frontBulbType = frontBulbType,
                                rearBulbType = rearBulbType,
                                batterySpecs = batterySpecs,
                                coolantType = coolantType,
                                nextRevisionDate = nextRevisionDate,
                                nextItvDate = nextItvDate,
                                firstRegistrationDate = firstRegistrationDate
                            )
                            
                            if (vehicleToEdit != null) {
                                viewModel.updateVehicle(vehicle)
                                isErrorSnackbar = false
                                coroutineScope.launch {
                                    snackbarHostState.showSnackbar(
                                        message = vehicleUpdatedSuccessfully,
                                        duration = SnackbarDuration.Short
                                    )
                                }
                                onVehicleAdded()
                            } else if (!isSaving) {
                                // Creation reports its result: stay on the form if it failed.
                                isSaving = true
                                viewModel.createVehicle(vehicle) { result ->
                                    isSaving = false
                                    val failure = when {
                                        result is DResponse.Success -> null
                                        (result as? DResponse.Error)?.error == GarageErrors.DUPLICATE_LOCAL_VIN -> vehicleDuplicateVin
                                        else -> errorAddingVehicle
                                    }
                                    isErrorSnackbar = failure != null
                                    coroutineScope.launch {
                                        snackbarHostState.showSnackbar(
                                            message = failure ?: vehicleAddedSuccessfully,
                                            duration = SnackbarDuration.Short
                                        )
                                    }
                                    if (failure == null) onVehicleAdded()
                                }
                            }
                        } else {
                            isErrorSnackbar = true
                            coroutineScope.launch {
                                snackbarHostState.showSnackbar(
                                    message = pleaseCompleteRequiredFields,
                                    duration = SnackbarDuration.Short
                                )
                            }
                        }
                    },
                    icon = Icons.Default.Done
                )
                
                Spacer(modifier = Modifier.height(80.dp))
            }
        }
    }

    if (showNoteImport && noteImportViewModel != null) {
        NoteImportDialog(
            viewModel = noteImportViewModel,
            sparePartCatalog = DefaultSparePartCatalog,
            onDismiss = {
                showNoteImport = false
                noteImportViewModel.reset()
            },
            onApply = { selection ->
                if (selection is NoteImportSelection.Vehicle) applyNoteSelection(selection)
                showNoteImport = false
                noteImportViewModel.reset()
            },
            onImportAll = onImportAllFromNote?.let { importAll ->
                { note, draft ->
                    showNoteImport = false
                    noteImportViewModel.reset()
                    importAll(note, draft)
                }
            }
        )
    }
}

/** Fields of the vehicle form that can be filled from a note. */
private enum class VehicleFormField {
    VIN, PLATE, BRAND, MODEL, YEAR, TYPE, COLOR, OWNER, ENGINE_DETAILS, ENGINE_OIL, FUEL,
    FRONT_TIRE, REAR_TIRE, CYLINDER_COUNT,
    FRONT_BULB, REAR_BULB, BATTERY, COOLANT,
    FRONT_PRESSURE_BELOW_160, REAR_PRESSURE_BELOW_160,
    FRONT_PRESSURE_ABOVE_160, REAR_PRESSURE_ABOVE_160,
    FIRST_REGISTRATION, NEXT_ITV,
}

/** 2.2 -> "2.2", 2.0 -> "2": a tire pressure without unnecessary trailing zeros. */
private fun formatTirePressure(value: Double): String =
    if (value % 1.0 == 0.0) value.toLong().toString() else value.toString()

/** Epoch millis to the "dd/MM/yyyy" a [DatePickerField] shows. */
private fun formatEpochDate(epochMillis: Long): String =
    DatetimeUtils.dateToSpecificFormat(
        DatetimeUtils.getDateFromMilis(epochMillis.toString()),
        format = QuipConstants.DateFormat.noUtcPatternSpanishWithoutTime,
    )
